/**
 * The frames the report shows (backend video_detection_report._select_moments, changed to start at 2 s): page 1's
 * hero frame and page 2's six moments, picked from the animals in view per frame of the kept tracks.
 */

export const NUM_MOMENTS = 6;
// the first second has no marks (a track is output once it has been tracked for 1 s): moments start after it
export const MOMENTS_FROM_SEC = 2;

// n frames evenly spaced over the pool, the frame with the most in view in place of the nearest one
const spread = (pool, inView, n) => {
	if (pool.length <= n) return pool;
	const picks = Array.from(
		{ length: n },
		(_, i) => pool[Math.round((i * (pool.length - 1)) / (n - 1))]
	);
	const peak = pool.reduce((best, f) => (inView[f] > inView[best] ? f : best), pool[0]);
	if (inView[peak] > 0 && !picks.includes(peak)) {
		let near = 0;
		picks.forEach((f, i) => {
			if (Math.abs(f - peak) < Math.abs(picks[near] - peak)) near = i;
		});
		picks[near] = peak;
	}
	return [...new Set(picks)].sort((a, b) => a - b);
};

/**
 * The moments: frames with animals in view from `fromSec` after the start of the analysed clip. With none there (a
 * clip under 2 s, or nothing in view after it), the backend rule: frames in view from the first, else every frame.
 */
export const selectMoments = (
	inView,
	fps,
	{ n = NUM_MOMENTS, fromSec = MOMENTS_FROM_SEC } = {}
) => {
	const from = Math.round(fromSec * fps);
	const frames = Array.from(inView.keys());
	const late = frames.filter(f => f >= from && inView[f] > 0);
	if (late.length) return spread(late, inView, n);
	const seen = frames.filter(f => inView[f] > 0);
	return spread(seen.length ? seen : frames, inView, n);
};

/** Page 1's frame: the first with the most animals in view; with none in view, the middle frame. */
export const heroFrame = index =>
	index.maxInView > 0 ? index.maxInViewFrame : Math.floor(index.nFrames / 2);
